import { render, staticRenderFns } from "./vendas.vue?vue&type=template&id=685b848b&scoped=true&"
import script from "./vendas.vue?vue&type=script&lang=js&"
export * from "./vendas.vue?vue&type=script&lang=js&"
import style0 from "./vendas.vue?vue&type=style&index=0&id=685b848b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b848b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VDataTable,VSkeletonLoader})
